/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Layout from '../components/layout/Layout';
import DataTable from '../components/common/DataTable';
import {Input,Select} from '../components/common/FormField';
import api from '../services/api';
import {fmtDateTime} from '../utils/helpers';

const unwrap=(r:any)=>r?.data?.data??r?.data??r;

export default function MortuaryIotPage(){
  const nav=useNavigate();
  const [devices,setDevices]=useState<any[]>([]);
  const [alerts,setAlerts]=useState<any[]>([]);
  const [readings,setReadings]=useState<any[]>([]);
  const [incidents,setIncidents]=useState<any[]>([]);
  const [chambers,setChambers]=useState<any[]>([]);
  const [form,setForm]=useState<any>({protocol:'HTTPS'});
  const [manual,setManual]=useState<any>({metric:'temperature'});
  const [msg,setMsg]=useState('');

  const load=async()=>{
    const [d,a,r,i,c]=await Promise.all([
      api.getMortuaryIotDevices(),api.getMortuaryIotAlerts(),api.getMortuaryIotReadings(),
      api.getMortuaryIotIncidents(),api.getMortuaryChambers(),
    ]);
    setDevices(unwrap(d)||[]);setAlerts(unwrap(a)||[]);setReadings(unwrap(r)||[]);
    setIncidents(unwrap(i)||[]);setChambers(unwrap(c)||[]);
  };
  useEffect(()=>{load().catch(e=>setMsg(e.response?.data?.message||'Could not load IoT'));},[]);

  return(
    <Layout>
      <div className="space-y-4">
        <div>
          <button className="text-xs text-[#02357A]" onClick={()=>nav('/mortuary')}>← Command centre</button>
          <h1 className="text-xl font-bold">Cold-storage monitors</h1>
          <p className="text-xs text-slate-500">Temperature and equipment alerts for mortuary chambers. To see who is in each tray, open Chambers.</p>
        </div>
        {msg&&<div className="text-sm bg-slate-50 border rounded-lg px-3 py-2">{msg}</div>}

        <div className="card p-3">
          <h3 className="font-semibold mb-2">Open alerts</h3>
          <DataTable hideSearch data={alerts} emptyTitle="No open alerts"
            columns={[
              {key:'severity',label:'Severity'},
              {key:'title',label:'Title'},
              {key:'chamber_number',label:'Chamber'},
              {key:'message',label:'Impact'},
              {key:'id',label:'',render:(r:any)=><button className="text-xs underline" onClick={async()=>{await api.ackMortuaryIotAlert(r.id);load();}}>Ack</button>},
            ]}/>
        </div>

        <div className="grid lg:grid-cols-2 gap-4">
          <div className="card p-3 space-y-2">
            <h3 className="font-semibold">Register logger</h3>
            <Input placeholder="Device code" value={form.deviceCode||''} onChange={e=>setForm({...form,deviceCode:e.target.value})}/>
            <Input placeholder="Name" value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})}/>
            <Select value={form.chamberId||''} onChange={e=>setForm({...form,chamberId:e.target.value})}>
              <option value="">Chamber</option>
              {chambers.map((c:any)=><option key={c.id} value={c.id}>{c.chamber_number}</option>)}
            </Select>
            <button className="btn-primary text-sm" onClick={async()=>{
              try{
                if(!form.deviceCode||!form.name){setMsg('❌ Device code and name are required');return;}
                const saved=unwrap(await api.saveMortuaryIotDevice(form));
                if(saved?.device_token) setMsg(`Device token (store on logger): ${saved.device_token}`);
                await api.saveMortuaryIotSensor({deviceId:saved.id,sensorCode:'TEMP',metric:'temperature',unit:'°C',warningMax:8,criticalMax:10});
                setForm({protocol:'HTTPS'});load();
              }catch(e:any){setMsg('❌ '+(e.response?.data?.message||'Could not save device'));}
            }}>Save device + temp sensor</button>
            <p className="text-[11px] text-slate-500">Loggers POST /api/mortuary-iot/ingest with header x-device-token and body readings[].sensorTs (original timestamp, not server time).</p>
          </div>
          <div className="card p-3 space-y-2">
            <h3 className="font-semibold">Manual / test reading</h3>
            <Select value={manual.deviceId||''} onChange={e=>setManual({...manual,deviceId:e.target.value})}>
              <option value="">Device</option>
              {devices.map((d:any)=><option key={d.id} value={d.id}>{d.name}</option>)}
            </Select>
            <Input type="number" step="0.1" placeholder="°C" value={manual.value||''} onChange={e=>setManual({...manual,value:e.target.value})}/>
            <button className="btn-secondary text-sm" onClick={async()=>{
              if(!manual.deviceId||manual.value===''||manual.value==null){setMsg('❌ Device and value are required');return;}
              try{
                await api.ingestMortuaryIot({deviceId:manual.deviceId,readings:[{value:Number(manual.value),sensorTs:new Date().toISOString(),metric:'temperature'}]});
                setMsg('Reading ingested');load();
              }catch(e:any){setMsg('❌ '+(e.response?.data?.message||'Ingest failed'));}
            }}>Ingest</button>
          </div>
        </div>

        <div className="card p-3">
          <h3 className="font-semibold mb-2">Devices</h3>
          <DataTable hideSearch data={devices} emptyTitle="No loggers"
            columns={[{key:'device_code',label:'Code'},{key:'name',label:'Name'},{key:'chamber_number',label:'Chamber'},{key:'last_seen_at',label:'Last seen',render:(r:any)=>fmtDateTime(r.last_seen_at)}]}/>
        </div>
        <div className="card p-3">
          <h3 className="font-semibold mb-2">Recent readings</h3>
          <DataTable hideSearch data={readings.slice(0,40)} emptyTitle="No readings"
            columns={[{key:'sensor_ts',label:'Sensor time',render:(r:any)=>fmtDateTime(r.sensor_ts)},{key:'device_name',label:'Device'},{key:'value',label:'Value'},{key:'buffered',label:'Buffered'}]}/>
        </div>
        <div className="card p-3">
          <h3 className="font-semibold mb-2">Incidents</h3>
          <DataTable hideSearch data={incidents} emptyTitle="No incidents"
            columns={[{key:'incident_number',label:'No'},{key:'title',label:'Title'},{key:'status',label:'Status'},
              {key:'id',label:'',render:(r:any)=>r.status!=='RESOLVED'&&<button className="text-xs underline" onClick={async()=>{await api.resolveMortuaryIncident(r.id,'Corrective action recorded');load();}}>Resolve</button>}]}/>
        </div>
      </div>
    </Layout>
  );
}
